"use strict";

exports.__esModule = true;
exports.USER_INPUT_OPERATORS = exports.CYCLE_OPERATORS = exports.CONDITION_OPERATORS = void 0;
var CONDITION_OPERATORS = exports.CONDITION_OPERATORS = [{
  value: "EQ",
  displayName: "="
}, {
  value: "NOT_EQ",
  displayName: "!="
}, {
  value: "GT",
  displayName: ">"
}, {
  value: "GTE",
  displayName: ">="
}, {
  value: "LT",
  displayName: "<"
}, {
  value: "LTE",
  displayName: "<="
}, {
  value: "CONTAINS",
  displayName: "contains"
}, {
  value: "DOES_NOT_CONTAIN",
  displayName: "does not contain"
}, {
  value: "STARTS_WITH",
  displayName: "starts with"
}, {
  value: "ENDS_WITH",
  displayName: "ends with"
}, {
  value: "IN",
  displayName: "in"
}, {
  value: "NOT_IN",
  displayName: "not in"
}
// not supported yet
// {
//   value: "OCCURS_EVERY",
//   displayName: "occurs every",
// },
];
var CYCLE_OPERATORS = exports.CYCLE_OPERATORS = [{
  value: "IS",
  displayName: "Is"
}, {
  value: "IS_NOT",
  displayName: "Is not"
}, {
  value: "BETWEEN",
  displayName: "Between"
}];
var USER_INPUT_OPERATORS = exports.USER_INPUT_OPERATORS = [{
  value: "IS",
  displayName: "Is"
}, {
  value: "IS_NOT",
  displayName: "Is not"
}];